import { io } from 'socket.io-client';

let socketInstance = null;

export const initSocket = (userId) => {
    if (socketInstance) return socketInstance;

    socketInstance = io(process.env.REACT_APP_API_BASE_URL, {
        transports: ['websocket'],
        reconnection: true,
    });

    socketInstance.on('connect', () => {
        console.log('✅ Socket.IO connected:', socketInstance.id);
        socketInstance.emit('register', userId); // Register userId with server
    });

    socketInstance.on('disconnect', () => {
        console.warn('⚠️ Socket.IO disconnected');
    });

    return socketInstance;
};

export const subscribeToSocketNotifications = (onNotification) => {
    if (!socketInstance) return;

    const events = [
        'leave-applied', 'leave-status-updated', 'payslip', 'asset-assigned',
        'award-given', 'compoff-applied', 'compoff-status-updated',
        'document-uploaded', 'document-approved', 'policy-added',
        'reimbursement-submitted', 'reimbursement-accepted', 'reimbursement-rejected',
        'project-allocation', 'project-reassignment', 'project-removed', 'project-created',
        'resignation-submitted', 'resignation-approved', 'resignation-rejected', 'resignation-withdrawn',
        'general'
    ];

    events.forEach(event => {
        socketInstance.on(event, (data) => {
            console.log(`📨 Socket.IO Notification [${event}]:`, data);
            onNotification(event, data);
        });
    });
};

export const disconnectSocket = () => {
    if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
        console.log('🔌 Socket.IO disconnected (logout)');
    }
};